export enum AuthType {
  CustomerRegistrationAuth = 0,
  PasswordResetLinkAuth = 1,
}
